import { render, staticRenderFns } from "./quiz-statusbar-component2.vue?vue&type=template&id=622f4fc7&"
import script from "./quiz-statusbar-component2.vue?vue&type=script&lang=ts&"
export * from "./quiz-statusbar-component2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports